import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationcolumnElFindRemovedParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationcolumnElFindRemovedParams, unknown>

const fetchReservationColumnRemovedList = async (params: ApiV2ReservationcolumnElFindRemovedParams) => {
  const { data } = await apiClient.v2.apiV2ReservationcolumnElFindRemoved(params);
  return checkApiResponse(data);
}

export const v2ReservationColumnRemovedKeys = {
  all: [QUERY_KEY.v2apiV2ReservationcolumnElFindRemoved] as const,
  list: (params: ApiV2ReservationcolumnElFindRemovedParams) => [...v2ReservationColumnRemovedKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationColumnFindRemovedQueryOptions(params))` */
export const v2ReservationColumnFindRemovedQueryOptions = (params: ApiV2ReservationcolumnElFindRemovedParams) => ({
  queryKey: v2ReservationColumnRemovedKeys.list(params),
  queryFn: () => fetchReservationColumnRemovedList(params),
})

export const useV2ReservationColumnFindRemovedQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationColumnRemovedKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationColumnRemovedList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
